/**
 * UTM Tracking: captura parametros de campanha na URL e salva em cookie (30 dias).
 * Usado no Register.jsx para enviar origem ao backend junto com cadastro.
 */

const UTM_COOKIE = 'fcod_utm';
const UTM_EXPIRES_DAYS = 30;
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
};

/** Captura UTMs da URL atual e salva em cookie. Chamar no App mount. */
export const captureUtmParams = () => {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const found = {};
  for (const key of UTM_KEYS) {
    const v = params.get(key);
    if (v) found[key] = v.trim().slice(0, 200);
  }
  if (Object.keys(found).length === 0) return;

  // Captura referrer tambem (abrasel.com.br, google.com, etc)
  if (document.referrer) {
    try {
      found.utm_referrer = new URL(document.referrer).hostname;
    } catch { /* noop */ }
  }
  setCookie(UTM_COOKIE, JSON.stringify(found), UTM_EXPIRES_DAYS);
};

/** Le UTMs salvas (cookie). Retorna objeto vazio se nenhum UTM. */
export const getStoredUtmParams = () => {
  const raw = getCookie(UTM_COOKIE);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed ? parsed : {};
  } catch {
    return {};
  }
};
